export const LAYOUT = {
	MAIN: 'main',
	AUTH: 'auth',
	CHECKOUT: 'checkout',
};
